import { IError } from '../../types/error';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EErrorActionTypes {
  Clear = 'ERROR/CLEAR',
  Set = 'ERROR/SET',
}

export type TSetError = ITypedReduxAction<EErrorActionTypes.Set, IError>;
export type TClearError = ITypedReduxAction<EErrorActionTypes.Clear, void>;

/**
 * Redux action, который записывает в store текст ошибки
 * @param {IError} IError - объект ошибки для состояния
 */
export const setError: (error: IError) => TSetError = actionGenerator<EErrorActionTypes.Set, IError>(
  EErrorActionTypes.Set,
);
/**
 * Redux action, который очищает ошибку в store
 */
export const clearError: () => TClearError = actionGenerator<EErrorActionTypes.Clear>(EErrorActionTypes.Clear);

export type TErrorActionTypes = TClearError | TSetError;
